// extracted by mini-css-extract-plugin
export default {"OrganizerLink":"OrganizerLink-module__OrganizerLink___2dsnK"};